import { lazy } from 'react'

export const SleepingTimeV1 = lazy(() => import('./v1/SleepingTimeV1'))
export const SleepingTimeV2 = lazy(() => import('./v2/SleepingTimeV2'))
export const KitSleepingTimeV1 = lazy(() => import('./kitV1/KitSleepingTimeV1'))
